module.exports = __webpack_public_path__ + "static/img/engine_item.8c3440c7.png";